(function () {
    if (window.__cartDrawerRedesignInitialized) return;
    window.__cartDrawerRedesignInitialized = true;

    var DEBUG_FLAG = 'CART_DRAWER_REDESIGN_DEBUG';
    var SCOPE_CLASS = 'cart-drawer-redesign-enabled';
    var FREE_SHIPPING_THRESHOLD = 75;
    var FREE_GIFT_THRESHOLD = 85;
    var FREE_GIFT_VARIANT_IDS = [44691816939718];
    var SHIPPING_MARKER_OFFSET = 60;
    var observer = null;
    var observerActive = false;
    var enhanceTimer = null;
    var cartTimer = null;
    var isEnhancing = false;
    var cartFetchInFlight = false;
    var cartFetchPending = false;
    var giftSyncTimer = null;
    var giftSyncInFlight = false;
    var giftSyncPending = null;
    var cartState = {itemCount: null, total: null};
    var debugState = {enhanceRuns: 0, mutationsObserved: 0, skippedDuringEnhance: 0, cartFetches: 0};

    window.KushaeCartDrawerRedesignDebug = window.KushaeCartDrawerRedesignDebug || {};
    window.KushaeCartDrawerRedesignDebug.loaded = true;
    window.KushaeCartDrawerRedesignDebug.state = debugState;

    function debugEnabled() {
        return window[DEBUG_FLAG] === true;
    }

    function describeElement(element) {
        if (!element) return null;
        var rect = element.getBoundingClientRect ? element.getBoundingClientRect() : null;
        return {
            tagName: element.tagName,
            id: element.id || '',
            className: typeof element.className === 'string' ? element.className : '',
            text: (element.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 140),
            rect: rect ? {
                top: Math.round(rect.top),
                left: Math.round(rect.left),
                width: Math.round(rect.width),
                height: Math.round(rect.height)
            } : null
        };
    }

    function logFound(label, element) {
        if (debugEnabled()) {
            console.log('[CartDrawerRedesign] ' + label, describeElement(element));
        }
    }

    function logDebug(label, data) {
        if (debugEnabled()) {
            console.log('[CartDrawerRedesign] ' + label, data || '');
        }
    }

    function addClass(element, className) {
        if (element && !element.classList.contains(className)) {
            element.classList.add(className);
        }
    }

    function toggleClass(element, className, force) {
        if (!element) return;
        if (force && !element.classList.contains(className)) {
            element.classList.add(className);
        } else if (!force && element.classList.contains(className)) {
            element.classList.remove(className);
        }
    }

    function setData(element, key, value) {
        if (element && element.dataset[key] !== value) {
            element.dataset[key] = value;
        }
    }

    function setStyle(element, property, value) {
        if (element && element.style[property] !== value) {
            element.style[property] = value;
        }
    }

    function ensureScope() {
        if (document.body) {
            document.body.classList.add(SCOPE_CLASS);
        }
    }

    function debounceEnhance() {
        if (isEnhancing) {
            debugState.skippedDuringEnhance += 1;
            logDebug('enhance skipped while already enhancing', debugState);
            return;
        }
        window.clearTimeout(enhanceTimer);
        enhanceTimer = window.setTimeout(function () {
            window.requestAnimationFrame(enhance);
        }, 140);
    }

    function refreshCartState() {
        window.clearTimeout(cartTimer);
        cartTimer = window.setTimeout(function () {
            if (cartFetchInFlight) {
                cartFetchPending = true;
                return;
            }

            cartFetchInFlight = true;
            debugState.cartFetches += 1;
            logDebug('/cart.js fetch', debugState);
            fetch('/cart.js', {credentials: 'same-origin'})
                .then(function (response) {
                    return response.ok ? response.json() : null;
                })
                .then(function (cart) {
                    if (!cart) return;
                    cartState.itemCount = cart.item_count;
                    cartState.total = cart.total_price / 100;
                    updateHeaderCartCount(cart.item_count);
                    scheduleAutomaticGiftSync(cartState.total >= FREE_GIFT_THRESHOLD);
                    debounceEnhance();
                })
                .catch(function () {
                })
                .then(function () {
                    cartFetchInFlight = false;
                    if (cartFetchPending) {
                        cartFetchPending = false;
                        refreshCartState();
                    }
                });
        }, 120);
    }

    function updateHeaderCartCount(count) {
        var itemCount = Number(count) || 0;
        Array.prototype.forEach.call(document.querySelectorAll('.cart-link__icon'), function (icon) {
            var countNode = icon.querySelector('.cart-link__count');

            if (itemCount < 1) {
                if (countNode) countNode.remove();
                return;
            }

            if (!countNode) {
                countNode = document.createElement('span');
                countNode.className = 'cart-link__count';
                icon.appendChild(countNode);
            }

            countNode.textContent = String(itemCount);
        });
    }

    function bindCartRequestWatcher() {
        if (window.__kushaeCartDrawerCountFetchWatcher) return;
        window.__kushaeCartDrawerCountFetchWatcher = true;

        function isCartMutationUrl(url) {
            return /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:[?#].*)?$/i.test(String(url || ''));
        }

        function requestUrl(input) {
            if (!input) return '';
            if (typeof input === 'string') return input;
            if (input.url) return input.url;
            return '';
        }

        var nativeFetch = window.fetch;
        if (typeof nativeFetch === 'function') {
            window.fetch = function () {
                var requestedUrl = requestUrl(arguments[0]);
                var responsePromise = nativeFetch.apply(this, arguments);

                responsePromise.then(function (response) {
                    var responseUrl = response && response.url ? response.url : '';
                    if (response && response.ok && (isCartMutationUrl(responseUrl) || isCartMutationUrl(requestedUrl))) {
                        refreshAfterCartControl();
                    }
                }).catch(function () {});

                return responsePromise;
            };
        }

        if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
            var nativeOpen = window.XMLHttpRequest.prototype.open;
            var nativeSend = window.XMLHttpRequest.prototype.send;

            window.XMLHttpRequest.prototype.open = function (method, url) {
                this.__kushaeCartMutationUrl = isCartMutationUrl(url);
                return nativeOpen.apply(this, arguments);
            };

            window.XMLHttpRequest.prototype.send = function () {
                if (this.__kushaeCartMutationUrl) {
                    this.addEventListener('loadend', function () {
                        if (this.status >= 200 && this.status < 300) {
                            refreshAfterCartControl();
                        }
                    });
                }

                return nativeSend.apply(this, arguments);
            };
        }
    }

    function stopObserver() {
        if (observer && observerActive) {
            observer.disconnect();
            observerActive = false;
        }
    }

    function startObserver() {
        if (!observer || observerActive || !document.body) return;
        observer.observe(document.body, {childList: true, subtree: true});
        observerActive = true;
    }

    function handleMutations(mutations) {
        debugState.mutationsObserved += mutations ? mutations.length : 1;
        if (isEnhancing) {
            debugState.skippedDuringEnhance += 1;
            logDebug('mutation skipped during enhancement', debugState);
            return;
        }
        debounceEnhance();
    }

    function refreshAfterCartControl() {
        [0, 250, 700].forEach(function (delay) {
            window.setTimeout(function () {
                refreshCartState();
                debounceEnhance();
            }, delay);
        });
    }

    function parseMoney(text) {
        var match = String(text || '').replace(/,/g, '').match(/\$\s*(\d+(?:\.\d{1,2})?)/);
        return match ? parseFloat(match[1]) : null;
    }

    function formatMoney(amount) {
        if (typeof amount !== 'number' || isNaN(amount)) return '$0.00';
        return '$' + amount.toFixed(2);
    }

    function getProgressFillWidth(total, shippingThreshold, giftThreshold, shippingPosition) {
        if (total <= shippingThreshold) {
            var shippingRatio = shippingThreshold > 0 ? Math.max(0, total / shippingThreshold) : 0;
            return 'calc(' + (shippingPosition * shippingRatio) + '% - ' + (SHIPPING_MARKER_OFFSET * shippingRatio) + 'px)';
        }

        var giftRange = Math.max(giftThreshold - shippingThreshold, 0.01);
        var giftRatio = Math.min(1, Math.max(0, (total - shippingThreshold) / giftRange));
        var percent = shippingPosition + (100 - shippingPosition) * giftRatio;
        var offset = SHIPPING_MARKER_OFFSET * (1 - giftRatio);
        return 'calc(' + percent + '% - ' + offset + 'px)';
    }

    function isAutomaticGiftItem(item) {
        var variantId = Number(item && (item.variant_id || item.id));
        return FREE_GIFT_VARIANT_IDS.indexOf(variantId) !== -1;
    }

    function syncSlideCartWithCart(cart) {
        if (!cart) return;
        if (typeof window.SLIDECART_SET_CART === 'function') {
            window.SLIDECART_SET_CART(cart);
        } else if (typeof window.SLIDECART_UPDATE === 'function') {
            window.SLIDECART_UPDATE(cart);
        }
        document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {bubbles: true, cancelable: false}));
    }

    function fetchAndSyncSlideCart() {
        return fetch('/cart.js', {credentials: 'same-origin'})
            .then(function (response) {
                return response.ok ? response.json() : null;
            })
            .then(function (cart) {
                syncSlideCartWithCart(cart);
                return cart;
            });
    }

    function scheduleAutomaticGiftSync(eligible) {
        giftSyncPending = eligible;
        window.clearTimeout(giftSyncTimer);
        giftSyncTimer = window.setTimeout(function () {
            if (giftSyncInFlight) return;

            var shouldHaveGift = giftSyncPending;
            giftSyncPending = null;
            giftSyncInFlight = true;

            fetch('/cart.js', {credentials: 'same-origin'})
                .then(function (response) {
                    return response.ok ? response.json() : null;
                })
                .then(function (cart) {
                    if (!cart) return null;
                    var giftItems = (cart.items || []).filter(isAutomaticGiftItem);

                    if (shouldHaveGift && giftItems.length === 0) {
                        return fetch('/cart/add.js', {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
                            body: 'id=' + encodeURIComponent(FREE_GIFT_VARIANT_IDS[0]) + '&quantity=1'
                        });
                    }

                    var giftQuantity = giftItems.reduce(function (quantity, item) {
                        return quantity + Number(item.quantity || 0);
                    }, 0);
                    if (giftItems.length > 0 && (!shouldHaveGift || giftItems.length > 1 || giftQuantity !== 1)) {
                        var updates = {};
                        giftItems.forEach(function (item, index) {
                            updates[item.key] = shouldHaveGift && index === 0 ? 1 : 0;
                        });
                        return fetch('/cart/update.js', {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: {'Content-Type': 'application/json'},
                            body: JSON.stringify({updates: updates})
                        });
                    }

                    return null;
                })
                .then(function (mutationResponse) {
                    if (!mutationResponse || !mutationResponse.ok) return null;
                    return fetchAndSyncSlideCart().then(function () {
                        refreshAfterCartControl();
                    });
                })
                .catch(function () {})
                .then(function () {
                    giftSyncInFlight = false;
                    if (giftSyncPending !== null) scheduleAutomaticGiftSync(giftSyncPending);
                });
        }, 40);
    }

    function getDrawerSubtotal(shell) {
        var selectors = [
            '.cdr-subtotal-amount',
            '.footer-subtotal-wrapper',
            '.slidecart-subtotal',
            '.amp-sc__footer-row--subtotal',
            '.footer-row'
        ];
        var values = [];

        selectors.forEach(function (selector) {
            Array.prototype.forEach.call(shell.querySelectorAll(selector), function (node) {
                var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
                if (!/subtotal|\$/i.test(text)) return;
                var amount = parseMoney(text);
                if (typeof amount === 'number' && !isNaN(amount)) values.push(amount);
            });
        });

        return values.length ? values[values.length - 1] : null;
    }

    function setTextWithHighlights(element, text) {
        if (!element || element.dataset.cdrSourceText === text) return;
        element.textContent = text;
        element.dataset.cdrSourceText = text;

        var source = element.textContent;
        var pattern = /(\$\s*\d[\d,.]*\s*USD|\bFREE\b)/ig;
        var match;
        var lastIndex = 0;
        var fragment = document.createDocumentFragment();
        var found = false;

        while ((match = pattern.exec(source)) !== null) {
            found = true;
            fragment.appendChild(document.createTextNode(source.slice(lastIndex, match.index)));
            var span = document.createElement('span');
            span.className = 'cdr-progress-highlight';
            span.textContent = match[0];
            fragment.appendChild(span);
            lastIndex = pattern.lastIndex;
        }

        if (!found) return;
        fragment.appendChild(document.createTextNode(source.slice(lastIndex)));
        element.replaceChildren(fragment);
    }

    function applyHeader(shell) {
        var header = shell.querySelector('header.header[data-testid="Header"], header.header');
        logFound('header element found', header);
        if (!header) return;
        addClass(header, 'cdr-header');
        setData(header, 'cdrEnhanced', 'true');

        var title = Array.prototype.slice.call(header.children).find(function (child) {
            return child.tagName && child.tagName.toLowerCase() === 'span';
        });
        logFound('title element found', title);

        if (title) {
            addClass(title, 'cdr-title');
            var count = title.querySelector('.cart-count');
            if (typeof cartState.itemCount === 'number') {
                if (cartState.itemCount > 0) {
                    if (!count) {
                        count = document.createElement('span');
                        count.className = 'cart-count';
                        title.appendChild(document.createTextNode(' '));
                        title.appendChild(count);
                    }
                    count.textContent = String(cartState.itemCount);
                } else if (count) {
                    count.remove();
                }
            }
            count = title.querySelector('.cart-count');
            if (count) addClass(count, 'cdr-title-count');
        }

        var close = header.querySelector('button[aria-label="close cart"]');
        logFound('close button found', close);
        if (close) addClass(close, 'cdr-close');
    }

    function applyBanner(shell) {
        var banner = shell.querySelector('.announcements[data-testid="Announcements"], .announcements');
        logFound('OB/GYN banner found', banner);
        if (banner && /OB\/GYN-Created Feminine Care/i.test(banner.textContent || '')) {
            addClass(banner, 'cdr-obgyn-banner');
            setStyle(banner, 'display', 'none');
            setData(banner, 'cdrEnhanced', 'true');
        }
    }

    function removeBuiltInUpsells(shell) {
        Array.prototype.forEach.call(shell.querySelectorAll('.upsells, [data-testid="Aupsells"], .upsell-options, .upsell-options-overlay'), function (node) {
            setStyle(node, 'display', 'none');
            node.setAttribute('aria-hidden', 'true');
        });
    }

    function truckSvg() {
        return '<svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.56497 14.9279C4.01691 14.3798 3.74288 13.7164 3.74288 12.9375H1.23328L1.47994 11.8125H4.03059C4.23403 11.3121 4.56216 10.9057 5.01497 10.5933C5.46778 10.2811 5.98125 10.125 6.55538 10.125C7.1295 10.125 7.64297 10.2811 8.09578 10.5933C8.54859 10.9057 8.87672 11.3121 9.08016 11.8125H14.2746L16.7453 1.125H4.42659L4.45247 1.01475C4.50722 0.720376 4.64963 0.477656 4.87969 0.286594C5.10975 0.0955313 5.38125 0 5.69419 0H18.1516L17.2406 3.9375H19.5795L22.6299 8.00494L21.6562 12.9375H20.3583C20.3583 13.7164 20.0842 14.3798 19.5362 14.9279C18.9881 15.476 18.3247 15.75 17.5458 15.75C16.7669 15.75 16.1034 15.476 15.5554 14.9279C15.0073 14.3798 14.7333 13.7164 14.7333 12.9375H9.36788C9.36788 13.7164 9.09384 14.3798 8.54578 14.9279C7.99772 15.476 7.33425 15.75 6.55538 15.75C5.7765 15.75 5.11303 15.476 4.56497 14.9279ZM15.9902 9.28125H21.2237L21.4228 8.27944L19.017 5.0625H16.9723L15.9902 9.28125ZM16.4728 2.25225L16.7453 1.125L14.2746 11.8125L14.5471 10.6853L15.4387 6.75225L16.4728 2.25225ZM0 8.99775L0.28125 7.87275H5.32209L5.04084 8.99775H0ZM2.25 5.06475L2.53125 3.93975H8.69709L8.41584 5.06475H2.25ZM6.55538 14.625C7.01831 14.625 7.41534 14.4595 7.74647 14.1286C8.07741 13.7975 8.24288 13.4004 8.24288 12.9375C8.24288 12.4746 8.07741 12.0775 7.74647 11.7464C7.41534 11.4155 7.01831 11.25 6.55538 11.25C6.09244 11.25 5.69541 11.4155 5.36428 11.7464C5.03334 12.0775 4.86788 12.4746 4.86788 12.9375C4.86788 13.4004 5.03334 13.7975 5.36428 14.1286C5.69541 14.4595 6.09244 14.625 6.55538 14.625ZM17.5458 14.625C18.0087 14.625 18.4058 14.4595 18.7369 14.1286C19.0678 13.7975 19.2333 13.4004 19.2333 12.9375C19.2333 12.4746 19.0678 12.0775 18.7369 11.7464C18.4058 11.4155 18.0087 11.25 17.5458 11.25C17.0828 11.25 16.6858 11.4155 16.3547 11.7464C16.0238 12.0775 15.8583 12.4746 15.8583 12.9375C15.8583 13.4004 16.0238 13.7975 16.3547 14.1286C16.6858 14.4595 17.0828 14.625 17.5458 14.625Z" fill="white"/></svg>';
    }

    function giftSvg() {
        return '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.1875 6.25H12.8125V13.125C12.8125 13.4702 12.5327 13.75 12.1875 13.75H2.8125C2.46732 13.75 2.1875 13.4702 2.1875 13.125V6.25Z" stroke="white" stroke-width="1.2"/><path d="M1.5625 3.75H13.4375V6.25H1.5625V3.75Z" stroke="white" stroke-width="1.2"/><path d="M7.5 3.75V13.75" stroke="white" stroke-width="1.2"/><path d="M7.5 3.75C7.5 2.54188 6.66667 1.25 5.625 1.25C4.93464 1.25 4.375 1.80964 4.375 2.5C4.375 3.19036 4.93464 3.75 5.625 3.75H7.5Z" stroke="white" stroke-width="1.2"/><path d="M7.5 3.75C7.5 2.54188 8.33333 1.25 9.375 1.25C10.0654 1.25 10.625 1.80964 10.625 2.5C10.625 3.19036 10.0654 3.75 9.375 3.75H7.5Z" stroke="white" stroke-width="1.2"/></svg>';
    }

    function getProgressThresholds(rewards) {
        var thresholds = {shipping: FREE_SHIPPING_THRESHOLD, gift: FREE_GIFT_THRESHOLD};
        var labels = rewards ? rewards.querySelectorAll('.rewards-tiers-container, [data-testid="TieredRewardsProgressLabelsItem"]') : [];

        Array.prototype.forEach.call(labels, function (node) {
            var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
            var amount = parseMoney(text);
            if (amount === null) return;
            if (/free\s*shipping/i.test(text)) thresholds.shipping = amount;
            if (/free\s*gift/i.test(text)) thresholds.gift = amount;
        });

        if (!thresholds.gift || thresholds.gift < thresholds.shipping) thresholds.gift = FREE_GIFT_THRESHOLD;
        return thresholds;
    }

    function normalizeSellingPlanText(text) {
        var value = String(text || '').replace(/\s+/g, ' ').trim();
        if (!value) return '';
        value = value.replace(/^Delivery every/i, 'Delivered every');
        value = value.replace(/\s*[-\u2013\u2014\u00b7]\s*Save\s*15%.*$/i, '');
        value = value.replace(/\s+Save\s*15%.*$/i, '');
        return value;
    }

    function findSellingPlanState(item) {
        var selectedText = '';
        var control = null;
        var selects = item.querySelectorAll('select');

        Array.prototype.some.call(selects, function (select) {
            var option = select.options && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
            var text = option ? option.textContent : select.value;
            text = normalizeSellingPlanText(text);
            if (!text || /variant|quantity/i.test(select.name || '')) return false;

            if (/one[-\s]?time purchase/i.test(text)) {
                selectedText = text;
                control = findSellingPlanControl(item, select);
                return true;
            }

            if (/(delivery|delivered)\s+every/i.test(text)) {
                selectedText = text;
                control = findSellingPlanControl(item, select);
                return true;
            }

            return false;
        });

        if (!selectedText) {
            var textNodes = item.querySelectorAll('.properties-key-value, .subscription-option');
            Array.prototype.some.call(textNodes, function (node) {
                if (node.classList && node.classList.contains('cdr-item-selling-plan-line')) return false;
                if (node.classList && node.classList.contains('upgrade-to-subscription')) return false;
                var text = normalizeSellingPlanText(node.textContent);
                if (/(delivery|delivered)\s+every/i.test(text)) {
                    selectedText = text.match(/(Delivered every[^-\u2013\u2014\u00b7,\n]*)/i);
                    selectedText = selectedText ? normalizeSellingPlanText(selectedText[1]) : text;
                    control = findSellingPlanControl(item, node);
                    return true;
                }
                return false;
            });
        }

        return {
            isOneTime: /one[-\s]?time purchase/i.test(selectedText),
            isSubscription: /(delivery|delivered)\s+every/i.test(selectedText),
            deliveryText: normalizeSellingPlanText(selectedText),
            control: control
        };
    }

    function findSellingPlanControl(item, source) {
        var node = source;
        while (node && node !== item) {
            if (node.classList) {
                if (node.classList.contains('item-container') || node.classList.contains('main') || node.classList.contains('main-top') || node.classList.contains('main-top-left')) {
                    break;
                }

                if (node.classList.contains('cdr-item-selling-plan-line')) {
                    return null;
                }

                var className = typeof node.className === 'string' ? node.className : '';
                var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
                if (
                    /selling|subscription|purchase-option|frequency/i.test(className) ||
                    /Subscription options/i.test(text) ||
                    (node.querySelector && node.querySelector('select') && /(Delivery every|Delivered every|One-time Purchase)/i.test(text))
                ) {
                    return node;
                }
            }
            node = node.parentElement;
        }

        return source && source.tagName && source.tagName.toLowerCase() === 'select' ? source.parentElement : null;
    }

    function ensureSellingPlanLine(item, details, title, state) {
        var line = item.querySelector('.cdr-item-selling-plan-line');
        if (!state.isSubscription || !state.deliveryText || state.isOneTime) {
            if (line) line.remove();
            toggleClass(item, 'cdr-item-has-subscription', false);
            toggleClass(item, 'cdr-selling-plan-expanded', false);
            toggleClass(item, 'cdr-selling-plan-open', false);
            return;
        }

        addClass(item, 'cdr-item-has-subscription');
        if (!line) {
            line = document.createElement('div');
            line.className = 'cdr-item-selling-plan-line';
            line.innerHTML = '<span class="cdr-item-selling-plan-delivery"></span><span class="cdr-dot" aria-hidden="true">&middot;</span><span class="cdr-item-selling-plan-save">Save 15%</span><button type="button" class="cdr-item-edit">Edit</button>';
            line.dataset.cdrEnhanced = 'true';
            if (title && title.parentNode) {
                title.parentNode.insertBefore(line, title.nextSibling);
            } else if (details) {
                details.appendChild(line);
            }
        }

        var delivery = line.querySelector('.cdr-item-selling-plan-delivery');
        if (delivery) delivery.textContent = state.deliveryText;

        var edit = line.querySelector('.cdr-item-edit');
        if (edit && edit.dataset.cdrBound !== 'true') {
            edit.addEventListener('click', function () {
                item.classList.toggle('cdr-selling-plan-expanded');
                item.classList.toggle('cdr-selling-plan-open');
            });
            edit.dataset.cdrBound = 'true';
        }
    }

    function hideOriginalSellingPlanText(item, state) {
        var candidates = item.querySelectorAll('.properties-key-value li, .properties-key-value span, .subscription-option');
        Array.prototype.forEach.call(candidates, function (node) {
            if (!node.classList) return;
            if (node.classList.contains('cdr-item-selling-plan-line')) return;
            if (node.closest && node.closest('.cdr-item-selling-plan-line')) return;
            if (node.classList.contains('upgrade-to-subscription') || (node.closest && node.closest('.upgrade-to-subscription'))) return;
            if (node.classList.contains('cdr-selling-plan-control') || (node.closest && node.closest('.cdr-selling-plan-control'))) return;
            if ((node.tagName && node.tagName.toLowerCase() === 'select') || (node.querySelector && node.querySelector('select'))) return;

            var text = normalizeSellingPlanText(node.textContent);
            toggleClass(node, 'cdr-original-selling-plan-hidden', state.isSubscription && !state.isOneTime && /(delivery|delivered)\s+every/i.test(text));
        });
    }

    function applySellingPlan(item, details, title) {
        var state = findSellingPlanState(item);
        ensureSellingPlanLine(item, details, title, state);

        Array.prototype.forEach.call(item.querySelectorAll('.cdr-selling-plan-control'), function (control) {
            toggleClass(control, 'cdr-selling-plan-control', control === state.control && state.isSubscription && !state.isOneTime);
        });

        if (state.control && state.isSubscription && !state.isOneTime) addClass(state.control, 'cdr-selling-plan-control');

        var upgradeBlock = item.querySelector('.upgrade-to-subscription');
        if (upgradeBlock) {
            toggleClass(upgradeBlock, 'cdr-subscription-options-block', state.isSubscription && !state.isOneTime);
        }

        hideOriginalSellingPlanText(item, state);
    }

    function ensureStableProgressLayout(rewards) {
        var layout = rewards.querySelector('.cdr-article-progress-layout');
        if (!layout) {
            layout = document.createElement('div');
            rewards.appendChild(layout);
        }

        if (layout.dataset.cdrProgressVersion !== '2') {
            layout.className = 'cdr-article-progress-layout cdr-progress-enhanced';
            layout.dataset.cdrEnhanced = 'true';
            layout.dataset.cdrProgressVersion = '2';
            layout.innerHTML = '<p class="cdr-progress-message"></p><div class="cdr-progress-bar-wrap"><div class="cdr-progress-thresholds"><span class="cdr-threshold cdr-threshold-shipping"></span><span class="cdr-threshold cdr-threshold-gift"></span></div><div class="cdr-progress-track"><div class="cdr-progress-fill"></div><span class="cdr-progress-marker cdr-progress-marker-shipping" aria-hidden="true" data-cdr-icon-added="true">' + truckSvg() + '</span><span class="cdr-progress-marker cdr-progress-marker-gift" aria-hidden="true" data-cdr-icon-added="true">' + giftSvg() + '</span></div><div class="cdr-progress-labels"><span class="cdr-label cdr-label-shipping">FREE SHIPPING</span><span class="cdr-label cdr-label-gift">FREE GIFT</span></div></div><div class="cdr-progress-helper"></div>';
        }

        return layout;
    }

    function applyProgress(shell) {
        var rewards = shell.querySelector('.rewards[data-testid="TieredRewards"], .rewards');
        logFound('progress wrapper found', rewards);
        if (!rewards) return;
        addClass(rewards, 'cdr-progress-section');
        setData(rewards, 'cdrEnhanced', 'true');

        var appMessage = rewards.querySelector('.rewards-pre-unlock-text p');
        logFound('progress message found', appMessage);

        var liveSubtotal = getDrawerSubtotal(shell);
        var total = typeof liveSubtotal === 'number' && !isNaN(liveSubtotal) ? liveSubtotal : cartState.total;
        if (typeof total !== 'number' || isNaN(total)) total = 0;

        var thresholds = getProgressThresholds(rewards);
        var shippingThreshold = thresholds.shipping;
        var giftThreshold = thresholds.gift;
        var shippingRemaining = Math.max(shippingThreshold - total, 0);
        var giftRemaining = Math.max(giftThreshold - total, 0);
        var shippingPosition = Math.min(100, Math.max(0, shippingThreshold / giftThreshold * 100));
        var layout = ensureStableProgressLayout(rewards);
        layout.style.setProperty('--cdr-shipping-position', shippingPosition + '%');
        layout.style.setProperty('--cdr-shipping-offset', SHIPPING_MARKER_OFFSET + 'px');
        scheduleAutomaticGiftSync(giftRemaining === 0);
        Array.prototype.forEach.call(rewards.children, function (child) {
            if (!child.classList || !child.classList.contains('cdr-article-progress-layout')) {
                addClass(child, 'cdr-progress-original');
                setStyle(child, 'display', 'none');
            }
        });

        var message = layout.querySelector('.cdr-progress-message');
        var barWrap = layout.querySelector('.cdr-progress-bar-wrap');
        var fill = layout.querySelector('.cdr-progress-fill');
        var shippingMarker = layout.querySelector('.cdr-progress-marker-shipping');
        var giftMarker = layout.querySelector('.cdr-progress-marker-gift');
        var shippingAmount = layout.querySelector('.cdr-threshold-shipping');
        var giftAmount = layout.querySelector('.cdr-threshold-gift');
        var helper = layout.querySelector('.cdr-progress-helper');

        var messageText;

        if (shippingRemaining > 0) {
            messageText = 'Add ' + formatMoney(shippingRemaining) + ' more for free shipping';
        } else if (giftRemaining > 0) {
            messageText = 'Add ' + formatMoney(giftRemaining) + ' more for a free gift';
        } else {
            messageText = 'You\u2019ve Got FREE USA Shipping and a free gift!';
        }

        setTextWithHighlights(message, messageText);

        fill.style.width = getProgressFillWidth(total, shippingThreshold, giftThreshold, shippingPosition);
        if (shippingMarker) shippingMarker.style.left = shippingPosition + '%';
        if (giftMarker) giftMarker.style.left = '100%';
        if (shippingAmount) {
            shippingAmount.textContent = formatMoney(shippingThreshold) + ' USD';
            shippingAmount.hidden = shippingRemaining === 0;
        }
        if (giftAmount) {
            giftAmount.textContent = formatMoney(giftThreshold) + ' USD';
            giftAmount.hidden = giftRemaining === 0;
        }
        toggleClass(barWrap, 'cdr-progress-prices-hidden', shippingRemaining === 0 && giftRemaining === 0);
        helper.textContent = '';
        helper.hidden = true;

        logFound('progress track found', layout.querySelector('.cdr-progress-track'));
        logFound('progress fill found', fill);
        logFound('helper text found', helper);
    }

    function applyItems(shell) {
        var items = shell.querySelectorAll('.items .item');
        if (!items.length) return;

        Array.prototype.forEach.call(items, function (item) {
            addClass(item, 'cdr-cart-item');
            setData(item, 'cdrEnhanced', 'true');

            var container = Array.prototype.slice.call(item.children).find(function (child) {
                return child.classList && child.classList.contains('item-container');
            }) || item.querySelector('.item-container');
            if (container) addClass(container, 'cdr-item-container');

            var image = item.querySelector('.item-image-anchor');
            if (image) {
                addClass(image, 'cdr-item-image');
                applyBlogProductImage(image);
            }

            var main = item.querySelector('.main');
            if (main) addClass(main, 'cdr-item-main');

            var mainTop = item.querySelector('.main-top');
            if (mainTop) addClass(mainTop, 'cdr-item-top');

            var mainTopLeft = item.querySelector('.main-top-left');
            if (mainTopLeft) addClass(mainTopLeft, 'cdr-item-details');

            var title = item.querySelector('.title');
            if (title) addClass(title, 'cdr-item-title');

            var properties = item.querySelector('.properties-key-value');
            if (properties) addClass(properties, 'cdr-item-meta');

            var bottom = item.querySelector('.main-bottom');
            if (bottom) addClass(bottom, 'cdr-item-bottom');

            var quantity = item.querySelector('.quantity-selector');
            if (quantity) addClass(quantity, 'cdr-item-quantity');

            var price = item.querySelector('.price-discount-block');
            if (price) addClass(price, 'cdr-item-prices');

            var remove = item.querySelector('button.remove');
            if (remove) {
                addClass(remove, 'cdr-item-remove');
            }

            Array.prototype.forEach.call(item.querySelectorAll('a, button'), function (control) {
                if ((control.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase() === 'edit') {
                    addClass(control, 'cdr-item-edit');
                }
            });

            applySellingPlan(item, mainTopLeft, title);
        });
    }

    function normalizeProductPath(url) {
        if (!url) return '';
        try {
            return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
        } catch (error) {
            return String(url).split(/[?#]/)[0].replace(/\/$/, '');
        }
    }

    function applyBlogProductImage(imageAnchor) {
        var productPath = normalizeProductPath(imageAnchor.getAttribute('href'));
        var imageData = window.KushaeCartBlogImages && window.KushaeCartBlogImages[productPath];
        var image = imageAnchor.querySelector('img');
        if (!imageData || !image) return;

        if (image.getAttribute('src') !== imageData.src) image.setAttribute('src', imageData.src);
        if (imageData.srcset && image.getAttribute('srcset') !== imageData.srcset) {
            image.setAttribute('srcset', imageData.srcset);
        }
        Array.prototype.forEach.call(imageAnchor.querySelectorAll('source'), function (source) {
            if (imageData.srcset && source.getAttribute('srcset') !== imageData.srcset) {
                source.setAttribute('srcset', imageData.srcset);
            }
        });
        setData(image, 'kushaeBlogImage', 'true');
    }

    function applyFooter(shell) {
        var footer = shell.querySelector('footer.footer, .footer');
        logFound('summary/footer wrapper found', footer);
        if (!footer) return;

        addClass(footer, 'cdr-summary-footer');
        setData(footer, 'cdrEnhanced', 'true');

        var subtotalRow = footer.querySelector('.amp-sc__footer-row--subtotal') || Array.prototype.slice.call(footer.querySelectorAll('.footer-row')).find(function (row) {
            return /subtotal/i.test(row.textContent || '');
        });
        logFound('subtotal row found', subtotalRow);
        if (subtotalRow) {
            addClass(subtotalRow, 'cdr-subtotal-row');

            var subtotalLabel = subtotalRow.querySelector('.subtotal-label span, .subtotal-label');
            if (subtotalLabel) {
                addClass(subtotalLabel, 'cdr-subtotal-label');
                if (typeof cartState.itemCount === 'number') {
                    setData(subtotalLabel, 'cdrItemCount', cartState.itemCount + ' ' + (cartState.itemCount === 1 ? 'item' : 'items'));
                }
            }

            var subtotalAmount = subtotalRow.querySelector('.slidecart-subtotal, .footer-subtotal-wrapper');
            if (subtotalAmount) addClass(subtotalAmount, 'cdr-subtotal-amount');
        }

        var checkoutButton = footer.querySelector('#slidecart-checkout-form button[name="checkout"], #slidecart-checkout-form button, form[action="/cart"] button[name="checkout"], form[action="/cart"] button');
        logFound('checkout button found', checkoutButton);
        if (checkoutButton) {
            addClass(checkoutButton, 'cdr-checkout-button');
            setData(checkoutButton, 'cdrArrowAdded', 'true');
        }

        var hasDiscountRow = false;
        Array.prototype.forEach.call(footer.querySelectorAll('.footer-row'), function (node) {
            if (node === subtotalRow || (subtotalRow && subtotalRow.contains(node))) return;
            var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
            var isDiscountRow = /discount|coupon|code|-\s*\$/i.test(text) || /discount|coupon/i.test(typeof node.className === 'string' ? node.className : '');
            toggleClass(node, 'cdr-discount-row', isDiscountRow);
            if (isDiscountRow) {
                setData(node, 'cdrEnhanced', 'true');

                var left = node.querySelector('.footer-row-flex, .amp-sc__footer-row--discount, .flex');
                if (left) addClass(left, 'cdr-discount-left');

                var code = node.querySelector('.footer-code');
                if (code) {
                    addClass(code, 'cdr-discount-code');
                    setData(code, 'cdrIconAdded', 'true');
                }

                var amount = node.querySelector('.slidecart-discount-amount');
                if (amount) addClass(amount, 'cdr-discount-amount');
                hasDiscountRow = true;
            } else {
                Array.prototype.forEach.call(node.querySelectorAll('.cdr-discount-left, .cdr-discount-code, .cdr-discount-amount'), function (child) {
                    toggleClass(child, 'cdr-discount-left', false);
                    toggleClass(child, 'cdr-discount-code', false);
                    toggleClass(child, 'cdr-discount-amount', false);
                });
            }
        });

        toggleClass(footer, 'cdr-has-discount', hasDiscountRow);
    }

    function enhance() {
        if (isEnhancing) {
            debugState.skippedDuringEnhance += 1;
            return;
        }

        isEnhancing = true;
        stopObserver();

        try {
            debugState.enhanceRuns += 1;
            ensureScope();
            var shell = document.getElementById('slidecarthq');
            logFound('drawer root found', shell);
            window.KushaeCartDrawerRedesignDebug.hasSlideCart = !!shell;
            if (!shell) return;

            addClass(shell, 'cdr-drawer-root');
            setData(shell, 'cdrEnhanced', 'true');
            window.KushaeCartDrawerRedesignDebug.enhancedAt = new Date().toISOString();
            logDebug('enhanceDrawer run', debugState);
            removeBuiltInUpsells(shell);
            if (shell.classList.contains('cartEmpty') || shell.querySelector('.empty')) {
                toggleClass(shell, 'cdr-has-routine-recommendations', false);
            }
            applyBanner(shell);
            applyHeader(shell);
            applyProgress(shell);
            applyItems(shell);
            applyFooter(shell);
        } finally {
            isEnhancing = false;
            startObserver();
        }
    }

    document.addEventListener('theme:cartchanged', function () {
        refreshCartState();
        debounceEnhance();
    });

    document.addEventListener('kushae:cartimagemapchanged', debounceEnhance);

    document.addEventListener('DOMContentLoaded', function () {
        ensureScope();
        bindCartRequestWatcher();
        refreshCartState();
        enhance();
        observer = new MutationObserver(handleMutations);
        startObserver();

        document.addEventListener('click', function (event) {
            if (!event.target.closest || !event.target.closest('#slidecarthq')) return;
            if (event.target.closest('.quantity-selector button, button.remove, .remove, [data-testid*="quantity"], [data-testid*="remove"]')) {
                refreshAfterCartControl();
            }
        });

        document.addEventListener('change', function (event) {
            if (!event.target.closest || !event.target.closest('#slidecarthq')) return;
            if (event.target.closest('.quantity-selector input, input[type="number"], select')) {
                refreshAfterCartControl();
            }
        });
    });

    window.addEventListener('pagehide', function () {
        if (observer) {
            observer.disconnect();
            observerActive = false;
        }
    });
})();
